var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnSelectedReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:report"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9857 7.58105L11.9857 2.58105H5.31901C4.87698 2.58105 4.45306 2.75665 4.1405 3.06921C3.82794 3.38177 3.65234 3.80569 3.65234 4.24772V17.5811C3.65234 18.0231 3.82794 18.447 4.1405 18.7596C4.45306 19.0721 4.87698 19.2477 5.31901 19.2477H15.319C15.761 19.2477 16.185 19.0721 16.4975 18.7596C16.8101 18.447 16.9857 18.0231 16.9857 17.5811V7.58105ZM7.81901 16.7477H6.15234V9.24772H7.81901V16.7477ZM11.1523 16.7477H9.48568V11.7477H11.1523V16.7477ZM14.4857 16.7477H12.819V14.2477H14.4857V16.7477ZM11.9857 8.41439H11.1523V4.24772L15.319 8.41439H11.9857Z",
    fill: "#9999CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnSelectedReportIcon);
export default __webpack_public_path__ + "static/media/unSelectedReportIcon.3e9142d3ed49b02558cef025b1441b7b.svg";
export { ForwardRef as ReactComponent };